import React, { useState, useEffect } from 'react'
import Errors from './Errors'
import defaultValue from '../Lib/defaultValue'

const Password = ({
  mode,
  storedData,
  showErrors,
  onChange,
  name,
  options: { label },
  validations,
  hideRepeat,
  onKeyPress,
}) => {
  const originalValue = defaultValue(name, storedData)
  const [value, setValue] = useState(originalValue)
  const [errors, setErrors] = useState([])
  const [currentValue, setCurrentValue] = useState('')
  const [currentRepeatedValue, setCurrentRepeatedValue] = useState('')

  const onChangeText = e => {
    setValue(e.target.value)
  }

  const onChangeRepeatedText = e => {
    setCurrentRepeatedValue(e.target.value)
  }

  useEffect(() => {
    if (value === '' && mode !== 'create') return
    const errs = Errors(value, validations, false, [], {
      repeated: currentRepeatedValue,
      mode,
    })
    onChange(name, value, errs)
    setErrors(errs)
  }, [value, currentRepeatedValue])

  const input = (
    <input
      name={name}
      className={`w-full rounded px-2 py-1 ${
        showErrors && errors.length > 0 ? 'border border-error' : ''
      } bg-white outline-none placeholder-gray`}
      type="password"
      placeholder={label}
      value={value}
      onChange={onChangeText}
      onKeyPress={onKeyPress}
    />
  )

  const inputRepeated = (
    <input
      name={name}
      className={`w-full rounded px-2 py-1 ${
        showErrors && errors.length > 0 ? 'border border-error' : ''
      } bg-white outline-none placeholder-gray`}
      type="password"
      placeholder={label}
      value={currentRepeatedValue}
      onChange={onChangeRepeatedText}
    />
  )

  return (
    <div className="md:flex">
      <div className="flex-1 mb-8 md:mb-0">
        <label>{label}{errors && errors.map(err => <span className="ml-4 text-xs">{err}</span>)}</label>
        {input}
      </div>
      {hideRepeat === true || (
        <div className="flex-1 md:ml-4">
          <label>{label} Repeat</label>
          {inputRepeated}
        </div>
      )}
    </div>
  )
}

export default Password
